<template>
  <div class="newOpratonSpace">
    <!-- <div class="returnButton" @click="returnButton">
      <i class="el-icon-arrow-left"></i>
      返回
    </div> -->
    <!-- 提交表单 -->
    <el-form
      ref="addOprationSpace"
      v-loading="opratonSpaceLoading"
      :model="form"
      :rules="rules"
      label-width="136px"
      label-position="left"
      :hide-required-asterisk="true"
    >
      <el-form-item label="运营位标题:" prop="title">
        <div class="input">
          <el-input
            v-model="form.title"
            :maxlength="16"
            show-word-limit
            placeholder="请输入运营位标题"
            class="inputBox"
          />
        </div>
      </el-form-item>
      <!-- <el-form-item label="排序:" prop="sort">
        <el-select v-model="form.sort" class="selectBox" placeholder="请选择">
          <el-option
            v-for="item in selectOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          />
        </el-select>
      </el-form-item> -->
      <el-form-item label="封面图:" prop="bannerUrl">
        <div class="bannerUrl">
          <FileUpload v-model="form.image_url" @onSuccess="handleBannerImgSuccess" />
          <div class="bannerUrlRight">
            <div class="explain">固定大小750*300px，且格式为png的图片</div>
            <div v-show="noBannerUrl" class="errorText">
              <i class="iconfont icon-ai54" />
              请选择750*300px，且格式为png的图片
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="跳转链接ID:" prop="redirect">
        <el-input
          class="urlBox"
          @keyup.native="urlBoxChange"
          v-model="form.redirect"
          :maxlength="255"
          placeholder="请输入跳转链接ID"
        />
      </el-form-item>
      <el-form-item class="submit" label-width="0">
        <el-button type="primary" @click="onSubmit('addOprationSpace')">保存</el-button>
      </el-form-item>
    </el-form>
    <el-dialog class="my-dialog" title="" :visible.sync="saveDialogVisible" width="30%" center>
      <span>是否保存</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="clickToSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import FileUpload from '@/components/fileUpload/index';
import {
  getBannerLimitApi /* 读取横幅数量上限 */,
  getBannerByIDApi /* 读取横幅信息 */,
  addBannerApi /* 新增横幅 */,
} from '@/api/releaseManagement';
import { BannerEntryType } from '@/utils/constant';

export default {
  name: 'OperationManageEdit',
  components: {
    FileUpload,
  },
  props: {
    // entryType: {
    //   type: String,
    //   default: 'doctor',
    // },
    // itemData: {
    //   type: Object,
    //   default: () => ({}),
    // },
  },
  data() {
    return {
      entryType: 'doctor',
      bannerId: '',
      noBannerUrl: false,
      saveDialogVisible: false, // 保存弹窗是否打开
      opratonSpaceLoading: true,
      selectOption: [
        {
          value: 1,
          label: 1,
          disabled: false,
        },
        {
          value: 2,
          label: 2,
          disabled: false,
        },
        {
          value: 3,
          label: 3,
          disabled: false,
        },
        {
          value: 4,
          label: 4,
          disabled: false,
        },
      ],
      indexValue: '' /* 排序选中项 */,
      form: {
        title: '' /* 标题 */,
        // sort: 1 /* 排序 */,
        redirect: '' /* 跳转链接ID */,
        image_url: '', // 图片地址
      },

      rules: {
        title: [{ required: true, message: '请输入运营位标题', trigger: 'blur' }],
        // bannerUrl: [
        //   { required: true, message: "请上传图片", trigger: "onUploadChange" },
        // ],
        // indexValue: [{ required: true, message: '请选择排序', trigger: 'change' }],
        // url: [{ required: true, message: "ID", trigger: "blur" }],
      },
      breadcrumb: [
        {
          menu_name: '发布管理',
        },
        {
          menu_name: '运营位管理',
          menu_path: 'operationManagement',
        },
      ],
      entryTypeMap: {
        doctor: '医生端',
        deputy: '代表端',
        h5: 'H5渠道',
      },
    };
  },
  created() {
    this.entryType = this.$route.query.entryType;
    this.bannerId = this.$route.query.bannerId || '';
    this.breadcrumb.push({
      menu_name: this.entryTypeMap[this.entryType],
      menu_path: 'operationManagement',
      menu_params: { entryType: this.entryType },
    });
    this.breadcrumb.push({ menu_name: this.bannerId ? '编辑运营位' : '新增运营位' });

    this.g_breadcrumb(this.breadcrumb);
    if (this.bannerId) {
      this.queryInfo();
    }
    this.querySort();
  },
  mounted() {
    // this.form = { ...this.itemData };
    // this.bannerId = this.itemData.banner_id || '';
  },
  methods: {
    /**
     * 获取排序上限
     */
    async querySort() {
      try {
        const res = await getBannerLimitApi();
        const { limit } = res;
        this.selectOption = this.selectOption.map((item) => {
          const temp = item;
          if (limit < item.value) {
            temp.disabled = true;
          }
          return temp;
        });
      } catch (err) {}
      this.opratonSpaceLoading = false;
    },
    urlBoxChange() {
      // this.form.redirect = this.form.redirect.replace(/[^\d.]/g, '');
    },
    /**
     * 获取运营信息
     */
    async queryInfo() {
      this.opratonSpaceLoading = true;
      try {
        const params = {
          banner_id: this.bannerId,
        };
        const res = await getBannerByIDApi(params);
        const bannerInfo = res.banner_info;
        this.form = bannerInfo;
      } catch (err) {
        console.log('error', err);
      }
      this.opratonSpaceLoading = false;
    },

    /**
     * 图片上传
     */
    handleBannerImgSuccess() {
      this.noBannerUrl = false;
    },

    /**
     * 修改或添加数据
     */
    async clickToSave() {
      this.opratonSpaceLoading = true;
      try {
        const params = {
          banner_info: {
            title: this.form.title,
            redirect: this.form.redirect ? this.form.redirect.trim() : '',
            // sort: this.form.sort,
            entry_type: BannerEntryType[this.entryType].name,
            image_url: this.form.image_url,
            banner_id: this.bannerId,
            status: this.bannerId ? this.form.status : 0,
          },
        };
        await addBannerApi(params);
        this.$message.success(this.bannerId ? '编辑成功' : '新增成功');
        setTimeout(() => {
          // this.returnButton({ isSaveSuccess: true });
          this.g_tourl(`/saas/operationManagement.html?entryType=${this.entryType}`, {});
        }, 1000);
      } catch (err) {
        console.log('error', err);
        this.$message.error(this.bannerId ? '编辑失败' : '新增失败');
      }
      this.opratonSpaceLoading = false;
      this.saveDialogVisible = false;
    },
    /* 保存数据 */
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.form.image_url) {
            this.noBannerUrl = true;
            return;
          }

          this.saveDialogVisible = true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.newOpratonSpace {
  .returnButton {
    height: 48px;
    line-height: 48px;
    color: #626366;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    display: inline-block;
    cursor: pointer;
  }
  .el-form {
    ::v-deep.el-form-item__label {
      font-size: 16px;
      color: #303133;
      &:before {
        display: none;
      }
    }
    ::v-deep.el-form-item__content {
      margin-left: 136px !important;
      line-height: 0;
    }
    ::v-deep.input {
      width: 664px;
      position: relative;
      .inputBox {
        width: 100%;
        height: 48px;
      }
      .inputValue {
        font-size: 16px;
        color: #909399;
        position: absolute;
        right: 16px;
        top: 50%;
        transform: translateY(-50%);
      }
      input {
        width: 664px;
        height: 48px;
      }
    }
    // ::v-deep.selectBox {
    //   width: 176px;
    //   input {
    //     height: 48px;
    //   }
    // }
    ::v-deep.upload-demo {
      .el-upload-dragger {
        width: 250px;
        height: 100px;
        .addIcon {
          font-size: 24px;
          font-weight: 700;
          color: rgba(0, 0, 0, 0.25);
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .bannerUrl {
      display: flex;
      .bannerUrlRight {
        height: 100%;
        margin-left: 40px;
        .explain {
          margin-top: 40px;
          font-size: 14px;
          color: #d7d7d7;
          height: 14px;
          margin-bottom: 10px;
        }
      }

      .errorText {
        height: 14px;
        font-size: 14px;
        color: #ea281b;
        display: inline-block;
        vertical-align: middle;

        .iconfont {
          color: #ea281b;
          font-size: 18px;
        }
      }
    }
    ::v-deep.urlBox {
      width: 664px;
      input {
        width: 664px;
        height: 48px;
      }
    }
    .promptSize {
      line-height: 16px;
      font-size: 14px;
      color: #909399;
    }
    p {
      font-size: 14px;
      color: #ff6d42;
    }
  }
  .submit {
    text-align: center;
    margin-top: 100px;
    .el-button {
      width: 216px;
      height: 48px;
      font-size: 16px;
      color: #ffffff;
    }
  }

  .my-dialog ::v-deep .el-dialog--center .el-dialog__body {
    text-align: center;
  }
}
</style>
